import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb as AntBreadcrumb } from 'antd';

function Breadcrumb() {
  return (
    <AntBreadcrumb
      items={[
        {
          title: (
            <NavLink id='breadcrumb-home-link' to='/producer/dashboard'>
              <HomeOutlined style={{ fontSize: 24 }} />
            </NavLink>
          )
        },
        {
          title: (
            <NavLink id='breadcrumb-bank-data-link' to='/producer/profile/bankdata'>
              Contas bancárias
            </NavLink>
          )
        },
        {
          title: 'Cadastro de conta bancária'
        }
      ]}
    />
  );
}

export { Breadcrumb };
